export const defaultBookingLimit: object = { adults: 100, childrens: 100 };
